export class LoadingVisController {
  private readonly visibleOnLoad: Element;
  private readonly hiddenOnLoad: Element;
  private readonly error: Element;

  constructor(
    visibleOnLoad: Element | null,
    hiddenOnLoad: Element | null,
    error: Element | null,
  ) {
    if (!visibleOnLoad) {
      throw new Error(
        'init LoadingVisController failed: visibleOnLoad container missing',
      );
    }
    if (!hiddenOnLoad) {
      throw new Error(
        'init LoadingVisController failed: hiddenOnLoad container missing',
      );
    }
    if (!error) {
      throw new Error(
        'init LoadingVisController failed: error container missing',
      );
    }

    this.visibleOnLoad = visibleOnLoad;
    this.hiddenOnLoad = hiddenOnLoad;
    this.error = error;
  }

  public startLoading(): void {
    this.visibleOnLoad.classList.remove('sc-hidden');
    this.hiddenOnLoad.classList.remove('sc-visible');
    this.error.classList.remove('sc-visible');
  }

  public finishLoading(success = true): void {
    this.visibleOnLoad.classList.add('sc-hidden');

    if (success) {
      this.hiddenOnLoad.classList.add('sc-visible');
    } else {
      this.error.classList.add('sc-visible');
    }
  }
}
